import { GalleryImages } from '@/shared/types/stylist';
import { User } from '@/shared/types/generated';

export const galleryImagesEqual = (
  a: GalleryImages,
  b: GalleryImages,
): boolean => {
  // Compare landscape images
  if (a.landscapeImage !== b.landscapeImage) {
    return false;
  }

  // Compare portrait images arrays
  if (a.portraitImages.length !== b.portraitImages.length) {
    return false;
  }

  // Compare each portrait image
  for (let i = 0; i < a.portraitImages.length; i++) {
    if (a.portraitImages[i] !== b.portraitImages[i]) {
      return false;
    }
  }

  return true;
};

export const getInitialValues = (user: User, isStylist: boolean | null) => {
  const phoneNumber = user?.phoneNumber?.startsWith('+1')
    ? user.phoneNumber.substring(2)
    : user?.phoneNumber || '';

  const stylingPreference = isStylist
    ? (user?.stylist?.aesthetics ?? [])
    : (user?.client?.aesthetics ?? []);

  return {
    profileFormData: {
      profileImage: user?.profilePicUrl || '',
      firstName: user?.firstName || '',
      lastName: user?.lastName || '',
      gender: user?.gender || null,
      birthDate: user?.birthDate ? new Date(user.birthDate) : undefined,
      phoneNumber: phoneNumber,
      maskedPhoneNumber: phoneNumber,
      shareAge: user?.client?.shareAge ?? false,
    },
    bioData: {
      bio: isStylist ? user?.stylist?.bio || '' : user?.client?.bio || '',
      tikTok: user?.stylist?.tiktok || '',
      instagram: user?.stylist?.instagram || '',
      substack: user?.stylist?.substack || '',
    },
    clientMeasurements: {
      sizingDetails: user?.client?.sizingDetails || '',
      height: user?.client?.height || '',
    },
    selectedExpertise: user?.stylist?.expertise || [],
    selectedStylingPreference: stylingPreference,
    galleryImages: {
      landscapeImage: user?.stylist?.landscapeImage || null,
      portraitImages: user?.stylist?.portraitImages || [],
    },
  };
};
